import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Tooltip } from 'reactstrap';
import IconHelper from './iconHelper';

const InfoLabel = ({
  id,
  label,
  showIcon,
  iconType,
  iconColor,
  iconStyles,
  iconLocation,
  onClick,
  toolTipText,
  module,
}) => {
  const [toggle, setToggle] = useState(false);
  const [placement, setPlacement] = useState('top');

  useEffect(() => {
    setPlacement(window?.pageYOffset < (module === 'Reports' ? 565 : 295) ? 'top' : 'bottom');
  }, [module]);

  return (
    <div className="info-label-section" onClick={onClick}>
      {showIcon && iconLocation === 'Left' && (
        <IconHelper
          iconType={iconType}
          iconColor={iconColor}
          className={classNames('icon-style', { ...iconStyles })}
          toolTipId={id}
        />
      )}
      <span> {label}</span>
      {showIcon && iconLocation === 'Right' && (
        <IconHelper
          iconType={iconType}
          iconColor={iconColor}
          className={classNames('icon-style', { ...iconStyles })}
          toolTipId={id}
        />
      )}
      {toolTipText && toolTipText.length > 0 && (
        <Tooltip
          placement={placement}
          isOpen={toggle}
          target={id}
          toggle={() => setToggle(!toggle)}
          autohide={false}
          innerClassName="tooltip-new"
        >
          {toolTipText}
        </Tooltip>
      )}
    </div>
  );
};

InfoLabel.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  showIcon: PropTypes.bool,
  iconType: PropTypes.string,
  iconColor: PropTypes.string,
  iconStyles: PropTypes.shape({}),
  iconLocation: PropTypes.string,
  onClick: PropTypes.func,
  toolTipText: PropTypes.string,
  module: PropTypes.string,
};

InfoLabel.defaultProps = {
  id: 'showToolTip',
  label: '',
  showIcon: false,
  iconType: 'FaInfoCircle',
  iconColor: '#B4B1B1',
  iconStyles: {},
  iconLocation: 'Right',
  onClick: () => {},
  toolTipText: '',
  module: '',
};

export default InfoLabel;
